"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TertiaryButton = exports.DangerTertiaryButton = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("./theme");
var _shared = require("./shared");
var _constants = require("../../utils/constants");
var _stack_v = require("../../layouts/stack_v2");
var _tokens = _interopRequireDefault(require("../../tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultButtonProps = {
  disabled: false,
  size: 'lg'
};
var TertiaryButtonWrapper = _styledComponents["default"].button.withConfig({
  displayName: "tertiary_buttons__TertiaryButtonWrapper"
})(["padding-top:0;padding-bottom:0;text-decoration:underline;transition:none;background:none;border:none;", " &&&{font-size:", "px;line-height:", "px;}&:active{box-shadow:none;}&:hover,&:focus{background:none;text-decoration:underline;border:none;}", " ", ""], function (_ref) {
  var iconPlacement = _ref.iconPlacement;
  if (iconPlacement === 'left') {
    return "padding-left: ".concat(_tokens["default"].spacing[0.5], ";");
  } else if (iconPlacement === 'right') {
    return "padding-right: ".concat(_tokens["default"].spacing[0.5], ";");
  }
}, function (_ref2) {
  var size = _ref2.size;
  return _theme.PrimaryButtonTheme[size].fontSize;
}, function (_ref3) {
  var size = _ref3.size;
  return _theme.PrimaryButtonTheme[size].lineHeight;
}, _shared.CommonButtonStyles, function (_ref4) {
  var theme = _ref4.extensibleTheme;
  return "\n    color: ".concat(theme["default"].color, ";\n    svg path {\n      fill: ").concat(theme["default"].color, ";\n    }\n\n    &:hover,\n    &:focus {\n      color: ").concat(theme.hover.color, ";\n      svg path {\n        fill: ").concat(theme.hover.color, ";\n      }\n    }\n  ");
});
var iconSize = function iconSize(size) {
  switch (size) {
    case 'sm':
      return 'xs';
    case 'md':
      return 'sm';
    case 'lg':
      return 'md';
  }
};
var spacingValue = function spacingValue(size) {
  switch (size) {
    case 'sm':
      return _tokens["default"].spacing[0.25];
    case 'md':
      return _tokens["default"].spacing[0.5];
    case 'lg':
      return _tokens["default"].spacing[1];
  }
};
var ThemeableTertiaryButton = function ThemeableTertiaryButton(props) {
  var children = props.children,
    extensibleTheme = props.theme,
    disabled = props.disabled,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    onClick = props.onClick,
    className = props.className,
    icon = props.icon,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'left' : _props$placement,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size;
  var buttonRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(TertiaryButtonWrapper, (0, _extends2["default"])({
    ref: buttonRef,
    extensibleTheme: extensibleTheme,
    disabled: disabled,
    type: type,
    "aria-disabled": props.disabled,
    onClick: onClick,
    className: className,
    size: size,
    iconPlacement: icon && placement
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_stack_v.Stack, {
    direction: placement == 'left' ? 'row' : 'row-reverse',
    spacing: spacingValue(size),
    alignItems: "center",
    justifyContent: "center"
  }, icon && /*#__PURE__*/React.createElement(icon, {
    size: iconSize(size)
  }), children));
};
ThemeableTertiaryButton.defaultProps = defaultButtonProps;
var TertiaryButton = exports.TertiaryButton = function TertiaryButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableTertiaryButton, (0, _extends2["default"])({}, props, {
    theme: _theme.TertiaryButtonTheme
  }));
};
TertiaryButton.displayName = 'TertiaryButton';
TertiaryButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'tertiary-button'
});
var DangerTertiaryButton = exports.DangerTertiaryButton = function DangerTertiaryButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableTertiaryButton, (0, _extends2["default"])({}, props, {
    theme: _theme.DangerTertiaryButtonTheme
  }));
};
DangerTertiaryButton.displayName = 'DangerTertiaryButton';
DangerTertiaryButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'danger-tertiary-button'
});